import { type GivingBase, type GivingDetail, createGivingBase, createGivingDetail } from 'models/giving';
import type {
  CommunityGivingContentObjectDetailDataObject,
  CommunityGivingContentObjectListDataObject,
  GivingContentObjectDetailDataObject,
  GivingContentObjectListDataObject,
  PublicCommunityGivingContentObjectDataObject,
} from 'models/service';
import {
  type CommunityContentObjectDetail,
  type CommunityContentObjectList,
  type PublicCommunityContentObject,
  createCommunityContentObjectDetail,
  createCommunityContentObjectList,
  createPublicCommunityContentObject,
} from '../contentable-type-content-objects';

export type CommunityGivingContentObject = {
  giving: GivingDetail;
  type: 'giving';
} & CommunityContentObjectDetail;

export type GivingContentObjectDetail = CommunityGivingContentObject;

export type PublicCommunityGivingContentObject = {
  giving: GivingDetail;
  type: 'giving';
} & PublicCommunityContentObject;

export type PublicGivingContentObject = PublicCommunityGivingContentObject;

export const createGivingContentObjectDetail = (data: GivingContentObjectDetailDataObject): GivingContentObjectDetail =>
  createCommunityGivingContentObject(data);

export const createPublicGivingContentObject = (
  data: PublicCommunityGivingContentObjectDataObject,
): PublicCommunityGivingContentObject => createPublicCommunityGivingContentObject(data);

export const createCommunityGivingContentObject = (
  data: CommunityGivingContentObjectDetailDataObject,
): CommunityGivingContentObject => ({
  ...createCommunityContentObjectDetail(data),
  giving: createGivingDetail(data.giving),
  type: 'giving',
});

export type CommunityGivingContentObjectList = {
  giving: GivingBase;
  type: 'giving';
} & CommunityContentObjectList;

export type GivingContentObjectList = CommunityGivingContentObjectList;

export const createGivingContentObjectList = (data: GivingContentObjectListDataObject): GivingContentObjectList =>
  createCommunityGivingContentObjectList(data);

export const createCommunityGivingContentObjectList = (
  data: CommunityGivingContentObjectListDataObject,
): CommunityGivingContentObjectList => ({
  ...createCommunityContentObjectList(data),
  giving: createGivingBase(data.giving),
  type: 'giving',
});

export const createPublicCommunityGivingContentObject = (
  data: PublicCommunityGivingContentObjectDataObject,
): PublicCommunityGivingContentObject => ({
  ...createPublicCommunityContentObject(data),
  giving: createGivingDetail(data.giving),
  type: 'giving',
});
